/**
 * Customer Information Modal Form Component
 * -----------------
 * Modal form for entering and updating customer information like email and phone number
 *
 * props
 * -----------------
 * initialCustomerInfo - the initial customer info in the modal form
 * open - boolean for whether or not the modal should be open
 * onClose - function that runs when modal is closed
 * onSubmit - function that is called with the new customer info as a parameter when the form is submitted
 * title - the title of the modal
 */

import { useState } from 'react'
import TextField from '@/gf/components/TextField'
import ModalForm from '@/gf/components/ModalForm'
import PhoneInput from '@/gf/components/PhoneInput'

interface CustomerInfo {
  email: string
  phoneNumber: string
}

type CustomerInfoModalFormC = React.FC<{
  initialCustomerInfo: CustomerInfo
  open: boolean
  onClose: () => void
  onSubmit: (newCustomerInfo: CustomerInfo) => void
  title?: string
  showEmail?: boolean
}>

const CustomerInfoModalForm: CustomerInfoModalFormC = ({
  initialCustomerInfo,
  open,
  onClose,
  onSubmit,
  title = 'Edit customer information',
  showEmail = false,
}) => {
  const [email, setEmail] = useState(initialCustomerInfo.email)
  const [phoneNumber, setPhoneNumber] = useState(initialCustomerInfo.phoneNumber)

  return (
    <ModalForm
      open={open}
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit({
          email,
          phoneNumber,
        })
      }}
      submitButtonText="Save"
      title={title}
    >
      <div className="flex flex-col gap-4 mt-8">
        {showEmail && (
          <TextField
            label="Email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            noErrorText
          />
        )}
        <PhoneInput required value={phoneNumber} onChange={setPhoneNumber} />
      </div>
    </ModalForm>
  )
}

export default CustomerInfoModalForm
